import {
  ArrowForward,
  HistoryOutlined,
  InsertDriveFileOutlined,
} from "@mui/icons-material";
import { Avatar, Card, CardMedia, Paper, styled, Tooltip } from "@mui/material";
import { Box } from "@mui/system";
import { Button, Typography } from "@platform/design-system";
import { useNavigate } from "react-router";

import { submitEvent } from "../../../utils/tracking";
import { Loader } from "../../../components";
import { ROUTE_NAMES } from "../../../constants";
import { formatDate } from "../../../utils";

// TODO(eslint) fix cycle
// eslint-disable-next-line import/no-cycle
import { MAX_DRAFT_IN_PAGE } from "./dashboard";

const MS_PER_DAY = 1000 * 60 * 60 * 24;

const RfpDraftsGridContainer = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(4,1fr)",
  [theme.breakpoints.down(1400)]: {
    gridTemplateColumns: "repeat(3,1fr)",
  },
}));

const RfpDraftLeftBorder = styled(Box)(({ theme }) => ({
  width: "0.25rem",
  backgroundColor: theme.palette.surfaces.neutral,
  height: "95%",
  svg: {
    color: theme.palette.brandSupporting.medium,
  },
  ".MuiAvatar-root": {
    position: "absolute",
    marginLeft: "-1%",
    marginTop: "0.7%",
  },
}));

const RfpDraftContainer = styled(CardMedia)(({ theme }) => ({
  display: "flex",
  minWidth: "17.313rem",
  margin: theme.spacing(2),
  p: {
    paddingBottom: "0.313rem",
    svg: {
      verticalAlign: "bottom",
      marginRight: "0.25rem",
    },
  },
}));

const RfpDraftsContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(5),
  marginTop: theme.spacing(3),
  width: "min-content",
  minWidth: "25rem",
  [theme.breakpoints.down(1400)]: {
    width: "100%",
  },
}));

const RfpDraftContent = styled(Box)(() => ({
  padding: "1rem 0rem 1rem 2rem",
  width: "100%",
  display: "flex",
  flexDirection: "column",
}));

const RfpDraftsHeader = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  display: "flex",
  justifyContent: "space-between",
}));

const dateFrom = (saved) =>
  parseInt((Date.now() - new Date(saved)) / MS_PER_DAY);

const RfpDrafts = (props) => {
  const rfpDrafts = props.rfpDrafts ?? [];
  const hasMoreRfps = rfpDrafts?.length > MAX_DRAFT_IN_PAGE;
  const drafts = hasMoreRfps ? rfpDrafts.slice(0, -1) : rfpDrafts;
  const navigate = useNavigate();

  const handleContinueToRfp = (id) => {
    navigate(`/${ROUTE_NAMES.RFP}`, {
      state: { prevPath: location.pathname, draftRfpId: id },
    });
    submitEvent("RFP Draft Continued", {
      rfp_id: id,
    });
  };

  return (
    <RfpDraftsContainer>
      <RfpDraftsHeader>
        <Typography variant="header-large">My Latest RFP Drafts</Typography>
        {hasMoreRfps && (
          <Button
            variant="tertiary"
            onClick={() =>
              navigate(`/${ROUTE_NAMES.RFPS}`, {
                state: { tabIndex: 1 },
              })
            }
          >
            view all drafts
          </Button>
        )}
      </RfpDraftsHeader>
      {props.loading ? (
        <Loader isCentered={false} sx={{ textAlign: "center" }} />
      ) : drafts.length ? (
        <RfpDraftsGridContainer>
          {drafts.map((rfp) => (
            <RfpDraftContainer key={rfp.id} component={Card}>
              <Box>
                <RfpDraftLeftBorder>
                  <Avatar
                    sx={({ palette }) => ({
                      bgcolor: palette.surfaces.primary,
                    })}
                  >
                    <InsertDriveFileOutlined />
                  </Avatar>
                </RfpDraftLeftBorder>
              </Box>
              <RfpDraftContent>
                <Tooltip title={rfp.metaData?.clientName || "N/A"} mb={2}>
                  <Typography noWrap>
                    <strong>{rfp.metaData?.clientName || "N/A"}</strong>
                  </Typography>
                </Tooltip>
                <Typography variant="body-medium" color="textSecondary">
                  <HistoryOutlined />
                  Saved {dateFrom(rfp.lastModifyDate)} days ago{" "}
                </Typography>
                <Typography variant="body-medium">
                  Created by{" "}
                  <strong>
                    {rfp.creator?.givenName
                      ? [rfp.creator.givenName, rfp.creator.surname || ""].join(
                          " ",
                        )
                      : "N/A"}
                  </strong>
                </Typography>
                <Typography variant="body-medium">
                  Created on <strong>{formatDate(rfp.creationDate)}</strong>
                </Typography>
                <Typography variant="body-medium">
                  Current Step <strong>{rfp.currentStep}</strong>
                </Typography>
                <Button
                  variant="tertiary"
                  endIcon={<ArrowForward />}
                  sx={{
                    mt: "auto",
                    textAlign: "start",
                    justifyContent: "flex-start",
                  }}
                  onClick={() => handleContinueToRfp(rfp.id)}
                >
                  Continue
                </Button>
              </RfpDraftContent>
            </RfpDraftContainer>
          ))}
        </RfpDraftsGridContainer>
      ) : (
        <Typography variant="body-medium">
          <em>No RFPs drafts found</em>
        </Typography>
      )}
    </RfpDraftsContainer>
  );
};

export default RfpDrafts;
